import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { Navigate } from 'react-router-dom';

const StrategyDetailPage = () => {
    const { sessionId } = useParams();
    const navigate = useNavigate();
    const { user } = useAuthStore();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const handleBackToHistory = () => {
        navigate('/marketing-chain/history');
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="container mx-auto px-4 py-6">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center justify-between">
                        <div>
                            <button
                                onClick={handleBackToHistory}
                                className="text-gray-600 hover:text-gray-900 mb-4 flex items-center"
                            >
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                                Volver al Historial
                            </button>
                            <h1 className="text-3xl font-bold text-gray-900 mb-2">
                                Detalle de Estrategia
                            </h1>
                            <p className="text-gray-600">
                                Sesión ID: {sessionId}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Contenido del detalle de estrategia */}
                <div className="bg-white rounded-lg shadow p-6">
                    <p className="text-gray-600">
                        Esta página mostrará los detalles de la estrategia de marketing para la sesión {sessionId}.
                    </p>
                    <p className="text-gray-600 mt-4">
                        Funcionalidad en desarrollo...
                    </p>
                </div>
            </div>
        </div>
    );
};

export default StrategyDetailPage; 